

import shader from "./shader/RainShader"
class Rain {
    constructor(option) {
        option=option || {};
        this._speed = option.speed || 10.0;
        this._mixNum =option.mixNum || 0.6;
        this._delegate = undefined;
    }

    set speed(speed) {
        this._speed = speed
        this._delegate && (this._delegate.uniforms.speed = speed)
        return this
    }

    get speed() {
        return this._speed
    }

    add() {
        if (this._delegate) {
            return;
        }

        this._delegate = new Cesium.PostProcessStage({
            fragmentShader: shader,
            uniforms: {
                speed: this._speed,
                mixNum: this._mixNum
            }
        })

        viewer.scene.postProcessStages.add(this._delegate)

    }

    remove() {

        if (this._delegate) {
            viewer.scene.postProcessStages.remove(this._delegate)
            this._delegate = undefined;
        }

    }
}

export default Rain;